import gnb from './gnb'
import orgmap from './orgmap'

export default {
    gnb,
    orgmap
}